import {atom} from 'jotai';
import {atomWithStorage} from 'jotai/utils';
import {StoreViewProviderState} from '@/_application/modules/stores/store-view.context';
import {StoreView} from '@/_application/modules/stores/model/store-view.model';
import {Region} from '__generated__/__types__';

export const defaultStoreView: StoreView = {
    region_id: 619,
    region_name: 'Hà Nội',
    store_code: 'hn_gen_two',
    scope: 'Miền Bắc',
    sort_order: 62,
};

export const defaultRegion: Region = {
    code: 'VN-63',
    id: 619,
    label: 'Hà Nội',
    __typename: 'Region',
};

export const defaultStoreViewState: StoreViewProviderState = {
    currentRegion: defaultRegion,
    currentStoreView: defaultStoreView,
    saveCurrentRegion(): void {},
    saveCurrentStoreView(): void {},
    handleOpenStoreSwitcherModal(): void {},
};

// Original atom.
export const storeViewAtom = atomWithStorage('store-view', defaultStoreViewState);
export const clearStoreViewAtom = atom(null, (_get, set, _data) => {
    return set(storeViewAtom, defaultStoreViewState);
});
export const currentStoreViewAtom = atom(
    get => get(storeViewAtom).currentStoreView,
    (get, set, data: StoreView) => {
        const prev = get(storeViewAtom);
        return set(storeViewAtom, {...prev, currentStoreView: data});
    },
);
export const currentRegionAtom = atom(
    get => get(storeViewAtom).currentRegion,
    (get, set, data: Region) => {
        const prev = get(storeViewAtom);
        return set(storeViewAtom, {...prev, currentRegion: data});
    },
);
